const validate = (validation = [], name, newValue, row, column) => {
  if (validation.filter(x => x.name == "number").length && isNaN(newValue)) {
    return {
      valid: false,
      message: `${name} should be numeric`,
    };
  }
  if (
    validation.filter(x => x.name == "gt").length &&
    newValue < validation.filter(x => x.name == "gt")[0].value
  ) {
    return {
      valid: false,
      message: `${name} should bigger than ${
        validation.filter(x => x.name == "gt")[0].value
      }`,
    };
  }
  if (
    validation.filter(x => x.name == "lt").length &&
    newValue > validation.filter(x => x.name == "lt")[0].value
  ) {
    return {
      valid: false,
      message: `${name} should bigger than ${
        validation.filter(x => x.name == "lt")[0].value
      }`,
    };
  }
  return true;
};

export default validate;
